module.exports = __webpack_public_path__ + "img/triangle-person-digging.20545219.svg";